export default "__VITE_ASSET__5a309a27__"